export enum Locale {
  en = 'en-US',
  zh = 'zh-CN',
  ru = 'ru-RU',
}
